import type { CoreOfficeDataType } from '~/types/offices';
import type { HostDataType } from '~/types/userTypes';
import * as gtag from '~/hooks/gtags.client';
import type { SupportedLanguage } from '~/config/i18n';

//ODP page view
export function ga4TrackViewItem(lang: SupportedLanguage, office: CoreOfficeDataType, hostData: HostDataType) {
  const officeDataPayload = getOfficeDataPayload(lang, office, hostData);
  const payload = officeDataPayload;

  trackEvent('view_item', payload);
}

//Contact request initiated
export function ga4TrackInitiateContactRequest(
  lang: SupportedLanguage,
  office: CoreOfficeDataType,
  hostData: HostDataType,
) {
  const officeDataPayload = getOfficeDataPayload(lang, office, hostData);
  const payload = { event: 'initiate_contact_request', ...officeDataPayload };

  trackEvent('initiate_contact_request', payload);
}

//Guest signup
export function ga4TrackGuestSignUp() {
  trackEvent('signup_guest');
}

export function ga4TrackHostSignUp() {
  trackEvent('signup_host');
}

export function ga4TrackViewSearchResults() {
  trackEvent('view_search_results');
}

//Contact request created
export function ga4TrackContactRequest(
  lang: SupportedLanguage,
  office: CoreOfficeDataType,
  hostData: HostDataType,
  possibleCommissionValue: number,
) {
  const officeDataPayload = getOfficeDataPayload(lang, office, hostData);
  const payload = {
    possibleCommissionValue: possibleCommissionValue.toString(),
    ...officeDataPayload,
  };

  trackEvent('contact_request', payload);
}

const trackEvent = (eventName: string, payload?: any) => {
  if (typeof window !== 'undefined' && window.dataLayer !== undefined && window.ENVIRONMENT === 'production') {
    gtag.event(eventName, payload);
  } else {
    console.log(`GA4 track: ${eventName} payload=`, payload);
  }
};

const getOfficeDataPayload = (lang: SupportedLanguage, office: CoreOfficeDataType, hostData: HostDataType) => {
  const pricePerMonthValue = () => {
    if (office.pricePerMonthValue) return office.pricePerMonthValue.toString();
    if (office.pricePerMonthFourDay) return office.pricePerMonthFourDay.toString();
    if (office.pricePerMonthThreeDay) return office.pricePerMonthThreeDay.toString();
    if (office.pricePerMonthTwoDay) return office.pricePerMonthTwoDay.toString();
    if (office.pricePerMonthOneDay) return office.pricePerMonthOneDay.toString();
    return '';
  };

  const payload = {
    item_id: office.id.toString(),
    item_name: office.title[lang],
    item_affiliation: '',
    item_brand: hostData.companyName || '',
    price: pricePerMonthValue(),
    currency: 'EUR',
    item_variant: office.officeType,
    item_category: office.capacity.toString(),
    item_category2: office.addressDetails.cityStateZip,
    item_category3: office.minDuration.toString(),
    item_category4: 'Furnished',
    item_category5: office.surface.toString(),
    item_country: office.addressDetails.country,
  };
  return payload;
};
